export default {
  name: 'UserAgreement'
};